import React from 'react'

import { Formik } from 'formik'
import Yup from '_zari/validation/_yup'

import { ZariContext } from '_zari/context'
import { Button, Form, Row, Col, Divider } from '_zari/core'

import { IdGen } from 'utils'

import * as FormGroups from './formGroups'
import * as Modals from './modals'
import * as Tables from './tables'

const ValidationSchema = Yup.object().shape({
  fechaEmision: Yup.string().required(),
  _idPlantillaCanje: Yup.string().required()
})

const commonReducer = (state, action) => {
  switch (action.type) {
    case 'agregar': {
      return [
        ...state,
        {
          ...action.payload,
          _idFila: IdGen.newId()
        }
      ]
    }
    case 'eliminar':
      return state.filter(val => val._idFila !== action.payload._idFila)
    default:
      return state
  }
}

const FormularioLetrasSection = ({ submitFunction, formikPagoRef, vTipoSocio, siguienteCorrelativoRef }) => {
  const __zariContext = React.useContext(ZariContext)

  const [letras, letrasDispatcher] = React.useReducer(commonReducer, [])

  const [mostrarControlLetrasModal, setMostrarControlLetrasModal] = React.useState(false)

  const formInitialValues = React.useMemo(() => {
    return {
      fechaEmision: '',
      moneda: 'SOLES',
      montoTotal: '',
      _idPlantillaCanje: ''
    }
  }, [])

  const clickAdminitrarLetras = React.useCallback(() => {
    if (!formikPagoRef.current.values.montoTotal) {
      __zariContext.snack('warning', 'No se ha seleccionado las cuotas para generar las letras.')
      return
    }

    if (!formikPagoRef.current.values.fechaEmision) {
      __zariContext.snack('warning', 'No se ha seleccionado fecha de emision para generar las letras.')
      return
    }

    setMostrarControlLetrasModal(true)
  }, [__zariContext, formikPagoRef])

  const submitHandler = (data, { setSubmitting }) => {
    if (letras.length === 0) {
      __zariContext.snack('warning', 'No se han registrado letras.')
      setSubmitting(false)
      return
    }

    const letrasNormalizado = letras.map(x => {
      return {
        fechaVencimiento: x.fechaVencimiento,
        importe: parseFloat(x.importe),
        numeroDocumento: parseFloat(x.numeroDocumento)
      }
    })

    submitFunction(
      {
        ...data,
        letras: letrasNormalizado
      },
      { setSubmitting }
    )
  }

  return (
    <>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema} innerRef={formikPagoRef}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue }) => (
          <Form>
            <FormGroups.PlantillaCanjeFormGroup
              fIsSubmitting={isSubmitting}
              iError={errors._idPlantillaCanje}
              iTouched={touched._idPlantillaCanje}
              setFieldValue={setFieldValue}
              vTipoSocio={vTipoSocio}
            />
            <FormGroups.FechaEmisionFormGroup fIsSubmitting={isSubmitting} iError={errors.fechaEmision} iTouched={touched.fechaEmision} />
            <FormGroups.MontoTotalFormGroup vMoneda={values.moneda} iValue={values.montoTotal} />
            <Divider />
            <Row className='mb-2'>
              <Col md={12}>
                <Button tiny block outline onClick={clickAdminitrarLetras}>
                  Adminitrar Letras
                </Button>
              </Col>
            </Row>
            {letras.length > 0 && <Tables.LetrasAsignadasTable letras={letras} />}
            <Row>
              <Col md={12} className='text-right'>
                <Button color='secondary'>Cancelar</Button>
                <Button id='button-formulariopagos-procesar' onClick={handleSubmit} disabled={isSubmitting}>
                  Procesar
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
      {mostrarControlLetrasModal && (
        <Modals.ControlLetrasModal
          show={mostrarControlLetrasModal}
          handleClose={() => setMostrarControlLetrasModal(false)}
          dispatch={letrasDispatcher}
          letras={letras}
          vFechaEmision={formikPagoRef.current.values.fechaEmision}
          vMontoTotal={formikPagoRef.current.values.montoTotal}
          vTipoSocio={vTipoSocio}
          siguienteCorrelativo={siguienteCorrelativoRef.current}
        />
      )}
    </>
  )
}
export default FormularioLetrasSection
